import type { HttpMock } from '#e2e-utils/mockScenarios';
import { InternalTicket } from '#services/ticketing/ticketing.service';

export const supportRequestOpenMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '/v3/internalTickets',
    },
    response: {
      status: 200,
      body: {
        statusCode: 9200001,
      } satisfies InternalTicket,
    },
  },
];
